export const availableMetaProperties = [
  {
    name: 'base',
    type: 'object'
  },
  {
    name: 'bodyAttributes',
    type: 'object'
  },
  {
    name: 'defaultTitle',
    type: 'string'
  },
  {
    name: 'htmlAttributes',
    type: 'object'
  },
  {
    name: 'link',
    type: 'object'
  },
  {
    name: 'meta',
    type: 'object'
  },
  {
    name: 'noscript',
    type: 'object'
  },
  {
    name: 'script',
    type: 'object'
  },
  {
    name: 'style',
    type: 'object'
  },
  {
    name: 'title',
    type: 'string'
  },
  {
    name: 'titleTemplate',
    type: 'string'
  }
];
